export const apiConstants = {
    // eslint-disable-next-line no-undef
    apiUrl:  'https://backend.edraakonline.com/api/v1',
    imgUrl: 'https://backend.edraakonline.com/',
    // apiUrl: 'http://localhost:8080/api/v1',
    // imgUrl: 'http://localhost:8080/',
  
  
  };
  